(function () {
	'use strict';

	angular
		.module('dcApp')
		.controller(
			'VersionElementsSharingModalController',
			VersionElementsSharingModalController
		);

	VersionElementsSharingModalController.$inject = [
		'$q',
		'ProjectService',
		'UserService',
	];

	function VersionElementsSharingModalController($q, ProjectService, UserService) {
		const vm = this;

		// Objet partagé avec la directive element-permission (reload, sélection courante)
		vm.permissionData = {};
		vm.members = [];
		vm.searchMembers = searchMembers;

		init();

		/**
		 * Mêmes données que l'onglet Partage - Eléments : les comptes connus
		 * croisés avec les membres de la version.
		 */
		function init() {
			$q.all([
				UserService.getProjectMembers(),
				ProjectService.getProject(vm.versionId),
			]).then(function (responses) {
				const users = responses[0] || [];
				const projectMembers =
					(responses[1] && responses[1].data && responses[1].data.members) || [];
				vm.members = [];
				for (let m in projectMembers) {
					let user = _.find(users, function (item) {
						return item.id === projectMembers[m].member_id;
					});
					if (user) {
						vm.members.push({
							id: user.id,
							name: user.name,
							is_group: user.is_group,
						});
					}
				}
			});
		}

		/**
		 * Recherche par libellé parmi les membres de la version.
		 */
		function searchMembers(query) {
			if (!query) {
				return [];
			}
			const lowerCaseQuery = query.toLowerCase();
			return vm.members.filter(function (member) {
				return (
					member.name && member.name.toLowerCase().indexOf(lowerCaseQuery) > -1
				);
			});
		}
	}
})();
